import type { Messages } from "./en";

export const fr: Messages = {
  brandShort: "Daaru Na'im",
  brandOrg: "Académie Daaru Na'im des sciences de la Charia du Nigeria",
  conferenceEdition: "18e Conférence internationale annuelle",
  nav: {
    home: "Accueil",
    cfp: "Appel à communications",
    schedule: "Programme",
    venue: "Lieu",
    papers: "Communications",
    pastEvents: "Événements passés",
    register: "Inscription",
    login: "Connexion",
    dashboard: "Tableau de bord",
    myPapers: "Mes communications",
    submit: "Soumettre une communication",
    reviews: "Évaluations",
    admin: "Administration",
    adminWorkspace: "Espace administration",
    participantWorkspace: "Espace participant",
    adminOverview: "Vue d'ensemble",
    adminRegistrations: "Inscriptions",
    adminReviewers: "Évaluateurs",
    adminPapers: "Communications",
    adminPastEvents: "Événements passés",
    adminSessions: "Sessions",
    adminCorrespondence: "Correspondance",
    adminMessages: "Messages",
    adminCertificates: "Certificats",
    adminReminders: "E-mails de rappel",
    adminSettings: "Paramètres de la conférence",
    viewPublicSite: "Voir le site public",
    accountSecurity: "Compte / Sécurité",
    logout: "Déconnexion",
    language: "Langue",
    langEn: "EN",
    langAr: "العربية",
    langFr: "FR",
  },
  pastEvents: {
    title: "Événements passés",
    lead: "Parcourez les publications et documents archivés de l'Académie.",
    year: "Année",
    view: "Voir",
    downloadPdf: "Télécharger le PDF",
    openPdf: "Ouvrir le PDF",
    openFullscreen: "Ouvrir le PDF dans un nouvel onglet",
    pdfUnavailable: "PDF pas encore disponible",
    backToArchive: "Retour aux événements passés",
    emptyTitle: "Aucun événement publié pour le moment",
    emptyBody: "Les éléments publiés de l'archive apparaîtront ici.",
  },
  hero: {
    ctaRegister: "S'inscrire à la conférence",
    ctaSubmit: "Soumettre une communication",
    countdown: "Compte à rebours avant la conférence",
    days: "Jours",
    hours: "Heures",
    minutes: "Minutes",
    seconds: "Secondes",
  },
  sections: {
    about: "À propos de la conférence",
    aboutBody:
      "Rencontre scientifique internationale organisée par l'Académie Daaru Na'im des sciences de la Charia du Nigeria pour explorer la jurisprudence des relations des musulmans avec autrui à la lumière de la Charia.",
    theme: "Thème de la conférence",
    dates: "Dates importantes",
    abstractDeadline: "Date limite des résumés",
    paperDeadline: "Date limite des communications complètes",
    conferenceDates: "Conférence internationale",
    nationalOptional: "Conférence nationale (facultative / pré-conférence)",
    cfp: "Appel à communications",
    cfpBody:
      "Les chercheurs sont invités à soumettre des résumés et des communications complètes en arabe, en anglais ou en français.",
    topics: "Thématiques suggérées",
    guidelines: "Consignes de soumission",
    programme: "Programme de la conférence",
    live: "Diffusion en direct",
    papersArchive: "Communications / Archives de la conférence",
    papersArchiveBody:
      "Parcourez les communications savantes des éditions de la conférence Daaru Na'im, y compris des échantillons en libre accès.",
    browseAllPapers: "Parcourir toutes les communications",
    submittedPapers: "Communications / Archives de la conférence",
    submittedPapersBody:
      "Parcourez les communications savantes des éditions de la conférence Daaru Na'im, y compris des échantillons en libre accès.",
    viewAllPapers: "Parcourir toutes les communications",
    venue: "Lieu et contact",
    organizer: "Organisateur",
    director: "Directeur général",
    contact: "Contact",
    finalCta: "Rejoindre la conférence",
    finalCtaBody:
      "Inscrivez-vous dès maintenant et soumettez votre communication. Les cartes physiques sont délivrées sur place.",
  },
  guidelines: {
    languages: "Langues acceptées : arabe, anglais ou français",
    arabicFont: "Arabe : Traditional Arabic, 18 pt",
    englishFont: "Anglais : Times New Roman, 12 pt",
    frenchFont: "Français : Times New Roman, 12 pt",
    format: "Soumettre au format Microsoft Word (.doc / .docx)",
  },
  register: {
    title: "Inscription à la conférence",
    subtitle: "Créez votre compte participant et recevez une confirmation d'inscription.",
    email: "Adresse e-mail",
    password: "Mot de passe",
    confirm: "Confirmer le mot de passe",
    fullName: "Nom complet",
    fullNameAr: "Nom complet (arabe, facultatif)",
    phone: "Téléphone / WhatsApp",
    country: "Pays",
    city: "Ville (facultatif)",
    institution: "Institution / Affiliation",
    role: "Titre académique / professionnel",
    preferredLang: "Langue préférée",
    organization: "Organisation (facultatif)",
    notes: "Notes (facultatif)",
    passiCode: "Code de récupération Passi",
    passiCreateLink: "Ouvrir Passi",
    passiInstructionsTitle: "Comment obtenir mon code de récupération Passi ?",
    passiSummarySteps:
      "1. Ouvrez Passi et cliquez sur Start creating\n2. Choisissez Generic portrait (1200×1200 square)\n3. Téléversez une photo ou utilisez la caméra\n4. Confirmez, recadrez, puis terminez Final checks\n5. Cliquez sur Stage and generate retrieval code, puis Confirm and upload\n6. Copiez le code de récupération à 6 caractères (pas le delete secret)\n7. Revenez ici et collez-le dans ce champ",
    passiOptionalNote:
      "La photo est facultative. Vous pouvez finaliser l'inscription sans code de récupération Passi.",
    passiOpenGuide: "Ouvrir le guide visuel étape par étape",
    passiGuideOpensNewTab: "S'ouvre dans un nouvel onglet pour conserver votre formulaire d'inscription.",
    submit: "Finaliser l'inscription",
    success: "Inscription réussie",
    successBody:
      "Votre inscription a été réalisée avec succès. Un e-mail de confirmation a été envoyé à votre adresse. Veuillez noter que la réception peut prendre quelques minutes. Si vous ne voyez pas le message dans votre boîte de réception, vérifiez également votre dossier Spam ou Courrier indésirable.",
    code: "Code d'inscription",
    cardAtVenueNote: "Votre carte physique de conférence sera délivrée à votre arrivée sur place.",
    goDashboard: "Accéder au tableau de bord",
  },
  passiGuide: {
    eyebrow: "Aide photo",
    title: "Guide visuel Passi étape par étape",
    intro:
      "Suivez ces captures pour créer un portrait de conférence dans Passi et copier un code de récupération à 6 caractères pour l'inscription Daaru Na'im.",
    optionalNote:
      "Ajouter une photo est facultatif. Vous pouvez vous inscrire à la conférence sans code de récupération Passi.",
    openPassi: "Ouvrir Passi",
    returnRegister: "Retour à l'inscription",
    copyCodeNotSecret:
      "Important : copiez uniquement le code de récupération à 6 caractères — pas le delete secret plus long.",
    step1Title: "Ouvrir Passi et commencer",
    step1Body: "Allez sur passi.fingletek.com et cliquez sur le bouton vert Start creating.",
    step1Callout: "Cliquez sur Start creating",
    step2Title: "Vous êtes dans Create photo",
    step2Body: "Passi ouvre la liste des modèles. Ensuite, choisissez un portrait générique de conférence.",
    step3Title: "Choisir Generic portrait (1200×1200 square)",
    step3Body:
      "Trouvez la carte Generic portrait (1200×1200 square) et cliquez sur Select this template. Ne choisissez pas un modèle passeport/visa.",
    step3Callout: "Select this template",
    step4Title: "Téléverser une photo ou utiliser la caméra",
    step4Body:
      "Choisissez Upload photo pour un fichier de votre appareil, ou Use camera capture pour prendre une nouvelle photo.",
    step4Callout: "Upload photo ou Use camera",
    step5Title: "Confirmer votre photo",
    step5Body: "Vérifiez l'aperçu, puis confirmez/continuez pour passer au recadrage et à l'édition.",
    step5Callout: "Confirm / continue",
    step6Title: "Ajuster et recadrer le portrait",
    step6Body: "Faites glisser pour centrer le visage, zoomez si besoin, puis continuez vers Final checks.",
    step6Callout: "Continue après recadrage",
    step7Title: "Examiner Final checks",
    step7Body:
      "Lisez les contrôles automatiques. Les avertissements sont acceptables pour un portrait de conférence — continuez vers le staging.",
    step8Title: "Stage and generate retrieval code",
    step8Body: "Faites défiler jusqu'à Stage for retrieval et cliquez sur Stage and generate retrieval code.",
    step8Callout: "Stage and generate retrieval code",
    step9Title: "Confirmer le téléversement",
    step9Body: "Passi demande une confirmation. Cliquez sur Confirm and upload.",
    step9Callout: "Confirm and upload",
    step10Title: "Trouver le code de récupération à 6 caractères",
    step10Body:
      "Le code court apparaît sous Stage for retrieval. C'est ce dont Daaru Na'im a besoin.",
    step10Callout: "Code de récupération (6 caractères)",
    step11Title: "Copier le code de récupération",
    step11Body: "Cliquez sur Copy à côté du code de récupération. Ne copiez pas le delete secret en dessous.",
    step11Callout: "Copy le code de récupération",
    step12Title: "Revenir à l'inscription Daaru Na'im",
    step12Body:
      "Revenez à l'onglet d'inscription, collez le code dans Passi retrieval code, et continuez. Vos champs déjà saisis doivent rester présents.",
  },
  login: {
    title: "Connexion participant / administrateur",
    submit: "Se connecter",
    noAccount: "Pas encore de compte ?",
  },
  setPassword: {
    title: "Définir votre mot de passe",
    lead: "Votre compte utilise un mot de passe temporaire. Choisissez un nouveau mot de passe avant de continuer.",
    currentPassword: "Mot de passe actuel (temporaire)",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le nouveau mot de passe",
    submit: "Enregistrer le mot de passe",
  },
  accountSecurity: {
    title: "Compte / Sécurité",
    lead: "Modifiez le mot de passe de votre compte conférence. Vous resterez connecté sur cet appareil.",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le nouveau mot de passe",
    policyHint: "Utilisez au moins 8 caractères. Ne réutilisez pas votre mot de passe actuel.",
    submit: "Mettre à jour le mot de passe",
    success: "Mot de passe mis à jour avec succès.",
    mismatch: "Le nouveau mot de passe et sa confirmation ne correspondent pas.",
  },
  dashboard: {
    title: "Tableau de bord du participant",
    registration: "Inscription à la conférence",
    registered: "Inscrit",
    badge: "Mon badge",
    cardAtVenue: "Carte de conférence",
    cardAtVenueHelp: "Les cartes physiques sont délivrées à l'enregistrement. Le téléchargement numérique n'est pas disponible.",
    papers: "Mes communications",
    schedule: "Programme de la conférence",
    liveNow: "En direct",
    profile: "Profil",
    noPapers: "Aucune communication soumise pour le moment",
    submitPaper: "Soumettre une communication",
    reviews: "Évaluations",
    reviewsHelp: "Communications qui vous sont assignées pour l'évaluation par les pairs.",
    openReviews: "Ouvrir les évaluations",
    editorialDecision: "Décision éditoriale",
    submitRevisedPaper: "Soumettre la version révisée",
    submitRevision: "Envoyer la révision",
    revisionFile: "Manuscrit révisé (.doc / .docx)",
    revisionNotes: "Réponse à la décision / Notes de révision",
    revisionNotesHelp: "Réponse courte facultative à la décision éditoriale.",
    revisionNeedFile: "Choisissez un manuscrit .doc ou .docx.",
    revisionSubmitted: "Révision {n} soumise. Les organisateurs ont été notifiés.",
    revisionLabel: "rév. {n}",
  },
  reviews: {
    title: "Évaluations",
    lead: "Communications assignées à vous en tant qu'examinateur désigné.",
    empty: "Aucune communication assignée pour le moment.",
    colTitle: "Titre",
    colAuthors: "Auteurs",
    colLanguage: "Langue",
    colAssigned: "Assignée le",
    colDue: "Échéance",
    colStatus: "Statut",
    statusAssigned: "Assignée",
    statusCompleted: "Terminée",
    openReview: "Ouvrir l'évaluation",
    viewReview: "Voir l'évaluation",
    reviewTitle: "Évaluation de la communication",
    downloadManuscript: "Télécharger le manuscrit",
    noManuscript: "Aucun manuscrit disponible",
    formTitle: "Votre évaluation",
    comments: "Commentaires",
    recommendation: "Recommandation",
    recommendationPlaceholder: "Choisir une recommandation",
    recAccept: "Accepter",
    recMinor: "Révision mineure",
    recMajor: "Révision majeure",
    recReject: "Rejeter",
    saveDraft: "Enregistrer le brouillon",
    submitFinal: "Soumettre l'évaluation finale",
    draftSaved: "Brouillon enregistré",
    submitted: "Évaluation soumise",
    submitNeedFields: "Les commentaires et une recommandation sont requis pour soumettre.",
    readOnlyHelp: "Cette évaluation a été soumise et est en lecture seule, sauf si un administrateur la rouvre.",
    submittedAt: "Soumise le",
  },
  paper: {
    title: "Soumettre une communication",
    paperTitle: "Titre de la communication",
    titleAlt: "Titre alternatif (facultatif)",
    language: "Langue",
    abstract: "Résumé",
    keywords: "Mots-clés",
    authors: "Auteurs",
    affiliation: "Affiliation",
    file: "Fichier de la communication (.doc / .docx)",
    notes: "Notes aux organisateurs (facultatif)",
    submit: "Soumettre la communication",
    success: "Communication soumise avec succès",
  },
  schedule: {
    title: "Programme de la conférence",
    preliminary: "",
    watchLive: "Regarder en direct",
    liveNow: "EN DIRECT",
    ended: "Séance terminée",
    upcoming: "La diffusion sera disponible au début de la séance",
    demoTitle: "Aperçu de diffusion de démonstration",
    demoBody: "Il s'agit d'un aperçu de démonstration — et non d'une diffusion en direct réelle.",
    liveStreamTitle: "Diffusion en direct",
  },
  papers: {
    title: "Communications",
    lead: "Recherchez dans les archives des communications savantes de toutes les éditions de la Conférence internationale annuelle Daaru Na'im.",
    archiveSummary: "Communications — {conferences} conférences",
    filteredSummary: "{papers} communications sur {conferences} conférences",
    search: "Recherche de communications",
    searchPlaceholder: "Rechercher titre, auteurs, affiliation, mots-clés, résumé…",
    clear: "Effacer",
    filterLanguage: "Langue",
    filterConference: "Conférence",
    conferenceAll: "Toutes les conférences",
    conferenceSelected: "{count} conférences sélectionnées",
    conferenceSearch: "Rechercher des conférences…",
    clearConferences: "Effacer les conférences",
    langAll: "Toutes les langues",
    langEnglish: "Anglais",
    langArabic: "Arabe",
    langFrench: "Français",
    results: "{count} communications",
    emptyTitle: "Aucune communication trouvée",
    emptyBody: "Essayez une autre recherche ou effacez vos filtres de conférence.",
    authors: "Auteurs",
    affiliation: "Affiliation",
    keywords: "Mots-clés",
    externalArchive: "Archive en libre accès / échantillon",
    readOnline: "Lire en ligne",
    downloadPdf: "Télécharger le PDF",
    pdfUnavailable: "PDF pas encore disponible",
    backToPapers: "Retour aux communications",
    prev: "Précédent",
    next: "Suivant",
    page: "Page {page} sur {pages}",
  },
  status: {
    submitted: "soumise",
    under_review: "en cours d'évaluation",
    minor_revision: "révision mineure",
    major_revision: "révision majeure",
    revised: "révisée",
    accepted: "acceptée",
    rejected: "refusée",
    published: "publiée",
    publishedAccepted: "publiée-acceptée",
  },
  venue: {
    title: "Lieu et contact",
    address: "Adresse",
    map: "Ouvrir dans Maps",
    mapTitle: "Carte du lieu de la conférence",
    mapLoading: "Chargement de la carte…",
  },
  verify: {
    title: "Vérification de l'inscription",
    valid: "Inscription valide",
    invalid: "Inscription introuvable",
  },
  admin: {
    title: "Administration de la conférence",
    statsRegs: "Inscriptions totales",
    statsPapers: "Communications soumises",
    statsAccepted: "Communications acceptées",
    statsUpcoming: "Séances à venir",
    statsCheckedIn: "Présents enregistrés",
    registrations: "Inscriptions",
    papers: "Communications",
    papersLead:
      "Évaluer → accepter/refuser → Préparer et publier pour diffuser un PDF aux couleurs de la conférence dans les archives publiques.",
    pastEvents: "Événements passés",
    pastEventsLead:
      "Ajouter, modifier, publier ou archiver les PDF d'événements passés pour l'archive publique.",
    pastEventsAdd: "Ajouter un événement passé",
    pastEventsEdit: "Modifier l'événement passé",
    pastEventsSlug: "Identifiant (slug)",
    pastEventsYear: "Année",
    pastEventsDate: "Date de l'événement (optionnelle)",
    pastEventsOrder: "Ordre d'affichage",
    pastEventsTitleEn: "Titre (anglais)",
    pastEventsTitleAr: "Titre (arabe)",
    pastEventsTitleFr: "Titre (français)",
    pastEventsDescEn: "Description (anglais)",
    pastEventsDescAr: "Description (arabe)",
    pastEventsDescFr: "Description (français)",
    pastEventsPdf: "Fichier PDF",
    pastEventsPublished: "Publié",
    pastEventsArchived: "Archivé",
    pastEventsPublish: "Publier",
    pastEventsUnpublish: "Dépublier",
    pastEventsCreated: "Événement passé créé",
    pastEventsSaved: "Événement passé enregistré",
    pastEventsDeleteConfirm: "Supprimer cet événement passé ?",
    sessions: "Séances",
    settings: "Paramètres de la conférence",
    reminders: "E-mails de rappel",
    remindersLead:
      "Les rappels automatiques suivent la date de début (Africa/Lagos) : une fois par semaine dès 2 mois avant, deux fois par semaine le dernier mois jusqu'à J-10, puis chaque jour jusqu'au début.",
    remindersEnabled: "Rappels activés",
    remindersOn: "Activés",
    remindersOff: "Désactivés",
    remindersEnable: "Activer les rappels",
    remindersDisable: "Désactiver les rappels",
    remindersNext: "Prochain rappel planifié",
    remindersNone: "Aucun",
    remindersTimezone: "Fuseau horaire",
    remindersTotals: "Totaux d'envoi",
    remindersSent: "Envoyés",
    remindersFailed: "Échecs",
    remindersEligible: "Destinataires éligibles",
    remindersRunNow: "Traiter les rappels dus maintenant",
    remindersRunDone: "Traitement des rappels terminé",
    remindersTest: "Envoyer un rappel de test",
    remindersTestHelp:
      "Envoie uniquement à l'adresse indiquée — jamais à toute la liste des participants.",
    remindersTestEmail: "E-mail de test contrôlé",
    remindersSendTest: "Envoyer le test",
    remindersTestSent: "Rappel de test envoyé/enregistré",
    remindersRecent: "Envois / échecs récents",
    remindersWindow: "Fenêtre / période",
    remindersScheduled: "Date planifiée",
    remindersSentAt: "Envoyé le",
    printSelected: "Télécharger les cartes sélectionnées",
    actions: "Actions",
    sendHotelReservation: "Envoyer la réservation d'hôtel",
    searchRegistrations: "Rechercher nom, e-mail, téléphone, institution, pays ou code…",
    cardType: "Type de carte",
    cardTypeParticipant: "Participant (B)",
    cardTypeHotel: "Participant + Hôtel (C)",
    previewCard: "Aperçu de la carte",
    printDownloadCard: "Imprimer / télécharger la carte (PDF)",
    downloadCardPng: "Télécharger l'image de la carte (PNG)",
    resendRegistration: "Renvoyer l'e-mail d'inscription",
    makeReviewer: "Désigner comme examinateur",
    removeReviewer: "Retirer le rôle d'examinateur",
    reviewerBadge: "Examinateur",
    reviewers: "Examineurs",
    reviewersLead:
      "Participants inscrits et examinateurs externes désignés pour l'évaluation des communications. Retirer le rôle ne supprime pas les inscriptions.",
    addReviewer: "Ajouter un examinateur",
    addReviewerTitle: "Ajouter un examinateur externe",
    addReviewerLead: "Crée un compte examinateur et envoie un e-mail d'invitation (le mot de passe temporaire n'est jamais affiché ici).",
    addReviewerFullName: "Nom complet",
    addReviewerEmail: "E-mail",
    addReviewerInstitution: "Institution",
    addReviewerPhone: "Téléphone",
    addReviewerCountry: "Pays",
    addReviewerTitleRole: "Titre académique / fonction",
    addReviewerExpertise: "Domaines d'expertise / mots-clés",
    addReviewerLanguage: "Langue préférée pour l'e-mail",
    addReviewerSubmit: "Créer l'examinateur",
    reviewerKind: "Type",
    reviewerKindRegistered: "Participant inscrit",
    reviewerKindExternal: "Examinateur externe",
    resendTempPassword: "Renvoyer / générer un nouveau mot de passe temporaire",
    resendTempPasswordDone: "Un nouveau mot de passe temporaire a été envoyé à l'examinateur par e-mail.",
    searchReviewers: "Rechercher nom, e-mail, institution ou code…",
    reviewersIncludeInactive: "Inclure les inactifs",
    reviewersEmpty: "Aucun examinateur désigné pour le moment.",
    reviewerName: "Nom",
    reviewerInstitution: "Institution",
    reviewerCode: "Code d'inscription",
    reviewerAssignedAt: "Date de désignation",
    reviewerStatus: "Statut",
    reviewerActive: "Actif",
    reviewerInactive: "Inactif",
    assignPapers: "Assigner des communications",
    assignPapersTitle: "Assigner des communications à l'examinateur",
    assignPapersLead: "Recherchez des communications soumises et assignez-en une ou plusieurs à cet examinateur désigné. Annuler une assignation ne supprime ni la communication ni l'examinateur.",
    assignPapersInactiveBlocked: "Cet examinateur est inactif et ne peut pas recevoir de nouvelles assignations.",
    assignPapersNeedSelection: "Sélectionnez au moins une communication à assigner.",
    assignPapersDone: "Communications assignées",
    assignmentCancelled: "Assignation annulée",
    currentAssignments: "Assignations actuelles",
    noAssignments: "Aucune assignation active pour le moment.",
    cancelledAssignmentsCount: "{n} assignation(s) annulée(s) conservée(s) pour l'historique.",
    availablePapers: "Communications disponibles",
    assignSearchPapers: "Rechercher titre, auteurs, mots-clés…",
    assignFilterLanguage: "Langue",
    filterAllLanguages: "Toutes les langues",
    assignFilterEdition: "Édition n°",
    assignFilterKeywords: "Mots-clés",
    assignDueDate: "Échéance (facultatif)",
    assignSelectedPapers: "Assigner la sélection",
    noAssignablePapers: "Aucune communication correspondante à assigner.",
    cancelAssignment: "Annuler l'assignation",
    assignColTitle: "Titre",
    assignColAuthors: "Auteurs",
    assignColLanguage: "Langue",
    assignColAssigned: "Assignée le",
    assignColDue: "Échéance",
    assignColEmail: "E-mail d'assignation",
    assignColReminder: "Dernier rappel",
    assignColStatus: "Statut",
    assignmentEmailSent: "Envoyé",
    assignmentEmailNotSent: "Non envoyé",
    resendAssignmentEmail: "Renvoyer l'e-mail d'assignation",
    assignmentEmailResent: "E-mail d'assignation mis en file pour renvoi",
    overdue: "En retard",
    reminderStatus7d: "7 jours avant",
    reminderStatus3d: "3 jours avant",
    reminderStatusDue: "Rappel le jour J",
    assignColEdition: "Édition",
    assignColKeywords: "Mots-clés",
    assignColPaperStatus: "Statut de la communication",
    viewSubmittedReview: "Voir l'évaluation",
    viewReviewTitle: "Évaluation soumise",
    viewReviewLead: "Consultez la recommandation et les commentaires de l'examinateur. La décision éditoriale finale n'est pas incluse à cette étape.",
    submittedReview: "Retour de l'examinateur",
    noSubmittedReview: "Aucune évaluation soumise pour le moment.",
    reopenReview: "Rouvrir pour modification",
    reviewReopened: "Évaluation rouverte pour l'examinateur",
    reviewDecision: "Évaluation & décision",
    reviewDecisionTitle: "Évaluation et décision éditoriale",
    reviewDecisionLead: "Les recommandations des examinateurs sont consultatives. Seul l'Admin enregistre la décision finale pour l'auteur.",
    reviewerFeedback: "Examinateurs assignés",
    pendingReviewsCount: "{completed} soumise(s) · {pending} en attente",
    noReviewersAssigned: "Aucun examinateur assigné à cette communication pour le moment.",
    reviewPending: "En attente",
    recordDecision: "Enregistrer la décision éditoriale",
    decisionAdvisory: "Cette décision est envoyée par e-mail à l'auteur. Les noms et commentaires des examinateurs ne sont pas inclus sauf si vous les écrivez dans le message.",
    decisionLabel: "Décision",
    decisionPlaceholder: "Choisir une décision",
    decisionAccept: "Acceptée",
    decisionMinor: "Révision mineure",
    decisionMajor: "Révision majeure",
    decisionReject: "Rejetée",
    decisionMessage: "Message à l'auteur",
    decisionMessageHelp: "Affiché à l'auteur et inclus dans l'e-mail de décision.",
    forceUpdateDecision: "Confirmer la mise à jour de la décision précédente (l'historique est conservé)",
    saveDecision: "Enregistrer la décision",
    updateDecision: "Mettre à jour la décision",
    decisionSaved: "Décision enregistrée",
    decisionNeedChoice: "Choisissez une décision avant d'enregistrer.",
    currentDecision: "Décision actuelle",
    decidedAt: "Décidée le",
    decisionHistory: "Historique des décisions",
    decisionUpdate: "mise à jour",
    manuscriptRevisions: "Révisions du manuscrit",
    manuscriptRevisionsHelp:
      "L'historique complet est conservé. Les évaluateurs reçoivent toujours le dernier manuscrit ; les versions antérieures restent accessibles à l'Admin.",
    currentRevision: "Révision actuelle",
    revisionNumber: "Révision {n}",
    revisionLatest: "dernière",
    downloadRevision: "Télécharger cette révision",
    generalCardsTitle: "Cartes de participation générale (catégorie A)",
    generalCardsHelp:
      "Cartes génériques pour le public non inscrit. Sans nom, photo ni QR. L'aperçu conserve le format physique ; les pages PDF ont la taille réelle du badge.",
    generalCardsCopies: "Exemplaires",
    previewGeneralCard: "Aperçu carte générique",
    downloadGeneralCards: "Télécharger / imprimer en masse",
    cardSettingsHelp:
      "Titres, chemin du blason et taille physique (card_width_mm / card_height_mm / card_safe_margin_mm). Blason : daarunaim/crest.png. Préset temporaire : 80 × 120 mm, marge sûre 5 mm.",
    cardPrintHelp:
      "Imprimez les PDF en taille réelle / 100 % (ne pas ajuster à la page). Les PNG sont en 300 DPI depuis la même mise en page.",
    closePreview: "Fermer l'aperçu",
    badgePreviewTitle: "Aperçu du badge",
    hotelTitle: "Réservation d'hôtel",
    hotelLead:
      "Rédigez et envoyez les détails de réservation d'hôtel à ce participant inscrit uniquement. Le destinataire est fixé à son e-mail d'inscription.",
    hotelRecipient: "Destinataire (fixe)",
    hotelRecipientFixed:
      "Cet e-mail est toujours adressé au participant sélectionné — le destinataire ne peut pas être modifié ici.",
    hotelCode: "Code d'inscription",
    hotelLanguage: "Langue préférée",
    hotelStatus: "Statut de la réservation",
    hotelLastSent: "Dernier envoi",
    hotelName: "Nom de l'hôtel",
    hotelAddress: "Adresse / lieu de l'hôtel",
    hotelCheckIn: "Date d'arrivée",
    hotelCheckOut: "Date de départ",
    hotelBookingRef: "Référence de réservation",
    hotelRoomType: "Type de chambre",
    hotelRoomNumber: "Numéro de chambre",
    hotelRoomNumberHelp: "Affiché clairement sur la carte d'accès hôtel",
    hotelContactPhone: "Téléphone de contact",
    hotelMapsUrl: "URL Google Maps / lieu (facultatif)",
    hotelNotes: "Notes / instructions",
    hotelSave: "Enregistrer le brouillon",
    hotelSaved: "Réservation d'hôtel enregistrée",
    hotelPreview: "Prévisualiser l'e-mail",
    hotelSend: "Envoyer l'e-mail de réservation",
    hotelResend: "Renvoyer / mettre à jour",
    hotelSent: "E-mail de réservation d'hôtel envoyé",
    hotelTo: "À",
    hotelHistory: "Historique d'envoi",
    markLive: "Marquer EN DIRECT",
    markEnded: "Marquer terminée",
    downloadBadge: "Télécharger la carte",
    checkIn: "Marquer présent",
    resend: "Renvoyer l'e-mail d'inscription",
    changeStatus: "Mettre à jour le statut",
    save: "Enregistrer les paramètres",

    messages: "Messages",
    messagesLead:
      "Envoyez un e-mail direct à toute adresse valide. Cela ne crée pas d'utilisateur, d'inscription ni de fiche évaluateur.",
    msgCompose: "Rédiger l'e-mail",
    msgComposeHelp:
      "L'objet et le message sont envoyés tels quels, dans le modèle vert de l'Académie.",
    msgRecipientEmail: "E-mail du destinataire",
    msgSubject: "Objet",
    msgBody: "Corps du message",
    msgSend: "Envoyer l'e-mail",
    msgSending: "Envoi…",
    msgSent: "E-mail envoyé avec succès.",
    msgNeedEmail: "L'e-mail du destinataire est requis.",
    msgNeedSubject: "L'objet est requis.",
    msgNeedBody: "Le corps du message est requis.",
    msgInvalidEmail: "Saisissez une adresse e-mail valide.",
    msgHistory: "Messages récents",
    msgHistoryLead: "Historique de livraison du registre e-mail du congrès.",
    msgHistoryEmpty: "Aucun message envoyé pour le moment.",
    msgColRecipient: "Destinataire",
    msgColSubject: "Objet",
    msgColSentAt: "Envoyé",

    correspondence: "Correspondance / Messages",
    correspondenceLead:
      "Rédigez les lettres officielles de l'Académie section par section. La sélection des destinataires sert uniquement à l'envoi — le texte n'est jamais généré automatiquement depuis le nom sélectionné.",
    corrHistory: "Historique de correspondance",
    corrHistoryLead: "Recherchez les lettres précédentes, retéléchargez le PDF exact ou renvoyez individuellement.",
    corrSearchRecipients: "Rechercher des destinataires",
    corrSearchPlaceholder: "Nom, e-mail ou type…",
    corrNoRecipients: "Aucun destinataire correspondant (admins exclus).",
    corrNeedRecipients: "Sélectionnez au moins un destinataire.",
    corrNeedTitle: "Saisissez l'objet.",
    corrNeedBody: "Saisissez le corps du message.",
    corrNeedAddressee: "Saisissez l'en-tête destinataire / destinataire.",
    corrPlainSectionInvalid: "Lettres, chiffres, espaces, virgules et points uniquement (pas de symboles comme / ou -).",
    corrFixRequired: "Veuillez renseigner les champs obligatoires avant de continuer.",
    corrRequired: "Obligatoire",
    corrRecipientsHeading: "Destinataires",
    corrComposeHeading: "Sections de la lettre",
    corrComposeHint:
      "Les champs suivent l'ordre de la lettre. Les champs obligatoires sont marqués d'un astérisque rouge.",
    corrSelectedNone: "Aucun sélectionné",
    corrSelectedCount: "{count} sélectionné(s)",
    corrSelect: "Sélectionner",
    corrRemoveRecipient: "Retirer le destinataire",
    corrRecipient: "Destinataire",
    corrType: "Type",
    corrTypeParticipant: "Participant",
    corrTypeRegisteredReviewer: "Évaluateur inscrit",
    corrTypeExternalReviewer: "Évaluateur externe",
    corrExternalHeading: "Destinataires non inscrits",
    corrExternalHelp:
      "Ajoutez toute adresse valide pour envoyer la même lettre signée — aucun compte ni inscription n'est créé.",
    corrExternalEmail: "E-mail externe",
    corrExternalName: "Nom affiché (optionnel)",
    corrExternalNamePlaceholder: "Nom pour la formule de politesse de l'e-mail",
    corrExternalAdd: "Ajouter l'e-mail",
    corrTypeExternal: "Non inscrit",
    corrAddressee: "En-tête destinataire / Destinataire",
    corrAddresseePlaceholder: "ex. Son Éminence Cheikh Dr. Abdel Rahim Al-Atri",
    corrPrayerHonorific: "Prière / formule honorifique",
    corrPrayerHonorificPlaceholder: "ex. Que Allah vous protege et vous preserve",
    corrLocation: "Lieu / Institution / Pays",
    corrLocationPlaceholder: "ex. Royaume du Maroc",
    corrGreeting: "Salutation",
    corrGreetingPlaceholder: "ex. Que la paix soit sur vous",
    corrTitle: "Objet",
    corrTitlePlaceholder: "Texte de l'objet (Objet : ajouté automatiquement)",
    corrBody: "Corps du message",
    corrRteBold: "Gras",
    corrRteItalic: "Italique",
    corrRteUnderline: "Souligné",
    corrRteAlignLeft: "Aligner à gauche",
    corrRteAlignCenter: "Centrer",
    corrRteAlignRight: "Aligner à droite",
    corrRteAlignJustify: "Justifier",
    corrRteBulletList: "Liste à puces",
    corrRteOrderedList: "Liste numérotée",
    corrRteUndo: "Annuler",
    corrRteRedo: "Rétablir",
    corrRteFontSize: "Taille de police",
    corrClosing: "Formule de clôture",
    corrClosingPlaceholder: "ex. Cordialement",
    corrDate: "Date de la lettre",
    corrPreviewPdf: "Aperçu PDF",
    corrPreviewing: "Préparation de l'aperçu…",
    corrSend: "Envoyer",
    corrSending: "Envoi…",
    corrPreviewReady: "Aperçu PDF ouvert dans un nouvel onglet.",
    corrSendSuccessOne: "Message envoyé avec succès à {name}.",
    corrSendSuccessMany: "Message envoyé avec succès à {count} destinataires.",
    corrSendPartial:
      "Envoi partiel : {sent} réussi(s), {failed} échec(s). Ouvrez l'historique pour inspecter et renvoyer.",
    corrSendAllFailed: "Échec de l'envoi pour les {failed} destinataire(s). Ouvrez l'historique pour inspecter.",
    corrNoticeSuccess: "Succès",
    corrNoticeError: "Erreur",
    corrViewHistory: "Ouvrir l'historique de correspondance",
    corrSearchHistory: "Rechercher destinataire ou titre",
    corrDateFrom: "Du",
    corrDateTo: "Au",
    corrFilter: "Filtrer",
    corrCreated: "Créé",
    corrDownload: "Télécharger PDF",
    corrResend: "Renvoyer",
    corrResendDone: "Lettre renvoyée",
    corrHistoryEmpty: "Aucune correspondance pour le moment.",
    corrStatusAll: "Tous les statuts",
    corrStatusGenerated: "Généré",
    corrStatusSent: "Envoyé",
    corrStatusFailed: "Échoué",

    certificates: "Certificats",
    certificatesLead:
      "Émettez des certificats de participation pour les participants et évaluateurs inscrits. Les administrateurs ne sont jamais sélectionnables.",
    certHistory: "Historique des certificats",
    certHistoryLead: "Recherchez les certificats précédents, retéléchargez le PDF exact ou renvoyez individuellement.",
    certSearchRecipients: "Rechercher des destinataires",
    certSearchPlaceholder: "Nom, e-mail ou type…",
    certNoRecipients: "Aucun destinataire correspondant (admins exclus).",
    certNeedRecipients: "Sélectionnez au moins un destinataire.",
    certFixRequired: "Veuillez sélectionner au moins un destinataire avant de continuer.",
    certRequired: "Obligatoire",
    certRecipientsHeading: "Destinataires",
    certOptionsHeading: "Options",
    certSelectedNone: "Aucun sélectionné",
    certSelectedCount: "{count} sélectionné(s)",
    certSelect: "Sélectionner",
    certRemoveRecipient: "Retirer le destinataire",
    certRecipient: "Destinataire",
    certType: "Type",
    certLanguage: "Langue",
    certLanguageAuto: "Auto (préférence du destinataire)",
    certLanguageEn: "Anglais",
    certLanguageAr: "Arabe",
    certLanguageFr: "Français",
    certLanguageAll: "Toutes les langues",
    certNotes: "Notes (optionnel)",
    certPersonalize: "Personnalisation par destinataire",
    certPersonalizeLead:
      "Définissez le titre/honorifique, le nom affiché et un message d'appréciation optionnel pour chaque destinataire. Prérempli depuis le titre d'inscription si disponible.",
    certHonorific: "Titre / honorifique",
    certHonorificNone: "Aucun",
    certHonorificSheikh: "Sheikh",
    certHonorificDr: "Dr.",
    certHonorificSheikhDr: "Sheikh Dr.",
    certHonorificMr: "Mr.",
    certHonorificSheikhAr: "الشيخ",
    certHonorificDrAr: "الدكتور",
    certHonorificSheikhDrAr: "الشيخ الدكتور",
    certHonorificCustom: "Personnalisé…",
    certHonorificCustomValue: "Titre personnalisé",
    certRecipientName: "Nom sur le certificat",
    certAppreciation: "Appréciation / message additionnel (optionnel)",
    certAppreciationPlaceholder: "Courte ligne personnalisée sous le nom…",
    certPreviewThisRecipient: "Utiliser pour l'aperçu",
    certPreviewPdf: "Aperçu PDF",
    certPreviewing: "Préparation de l'aperçu…",
    certSend: "Envoyer",
    certSending: "Envoi…",
    certPreviewReady: "Aperçu PDF ouvert dans un nouvel onglet.",
    certSendSuccessOne: "Certificat envoyé avec succès à {name}.",
    certSendSuccessMany: "Certificat envoyé avec succès à {count} destinataires.",
    certSendPartial:
      "Envoi partiel : {sent} réussi(s), {failed} échec(s). Ouvrez l'historique pour inspecter et renvoyer.",
    certSendAllFailed: "Échec de l'envoi pour les {failed} destinataire(s). Ouvrez l'historique pour inspecter.",
    certNoticeSuccess: "Succès",
    certNoticeError: "Erreur",
    certViewHistory: "Ouvrir l'historique des certificats",
    certSearchHistory: "Rechercher destinataire ou notes",
    certDateFrom: "Du",
    certDateTo: "Au",
    certFilter: "Filtrer",
    certCreated: "Créé",
    certDownload: "Télécharger PDF",
    certResend: "Renvoyer",
    certResendDone: "Certificat renvoyé",
    certHistoryEmpty: "Aucun certificat pour le moment.",
    certStatusAll: "Tous les statuts",
    certStatusGenerated: "Généré",
    certStatusSent: "Envoyé",
    certStatusFailed: "Échoué",

    saved: "Enregistré",
    search: "Rechercher…",
    filterAll: "Tous",
    colTitle: "Titre",
    colAuthor: "Auteur",
    colLanguage: "Langue",
    colSubmitted: "Soumise le",
    colStatus: "Statut",
    colFile: "Fichier",
    colWorkflow: "Flux de travail",
    preparePublish: "Préparer et publier",
    editPublication: "Modifier la publication",
    publishTitle: "Publier la communication",
    publishLead:
      "Enrichissez le manuscrit accepté avec l'identité visuelle de la conférence et les métadonnées de publication, prévisualisez le PDF, puis publiez-le dans les archives publiques. Le fichier Word de l'auteur reste privé.",
    publishNeedAccept: "Acceptez d'abord la communication (statut = acceptée) avant de publier.",
    publishSuccess: "Publiée dans les archives publiques des communications.",
    currentStatus: "Statut actuel",
    publicYes: "archives publiques",
    viewPdf: "Voir le PDF",
    manuscript: "Manuscrit de l'auteur",
    downloadWord: "Télécharger le manuscrit Word",
    viewPublicPdf: "Voir le PDF public",
    fieldTitle: "Titre",
    fieldTitleAlt: "Titre alternatif",
    fieldAuthors: "Auteurs",
    fieldAffiliation: "Affiliation(s)",
    fieldAbstract: "Résumé",
    fieldKeywords: "Mots-clés",
    fieldAcknowledgements: "Remerciements",
    fieldLicense: "Licence",
    includeLogo: "Inclure le logo de la conférence Daaru Na'im sur la couverture du PDF",
    uploadCameraReady: "Téléversement facultatif d'un PDF prêt à publier",
    uploadCameraReadyHelp:
      "S'il est fourni, ce PDF est publié tel quel. Sinon, la plateforme génère un PDF aux couleurs de la conférence à partir des champs ci-dessus (logo, affiliations, DOI, ISBN, remerciements, résumé).",
    previewPdf: "Prévisualiser le PDF",
    publishNow: "Publier dans les archives",
  },
  common: {
    loading: "Chargement…",
    error: "Une erreur s'est produite",
    back: "Retour",
    view: "Voir",
    download: "Télécharger",
    print: "Imprimer",
    close: "Fermer",
    cancel: "Annuler",
    save: "Enregistrer",
    edit: "Modifier",
    delete: "Supprimer",
    mainNav: "Navigation principale",
    poweredBy: "Propulsé par",
    copyrightFingletek: "© Fingletek",
    fingletekPhone: "+358 44 0685538",
    skipToContent: "Aller au contenu",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    pageOf: "Page {page} sur {pages}",
    previousPage: "Précédent",
    nextPage: "Suivant",
    rowsPerPage: "Lignes par page",
    showingCount: "Affichage {from}–{to} sur {total}",
  },
};
